<template>
  <div>
    请选择支付方式？：

  </div>
</template>

<script>
export default {

}
</script>

<style>
</style>
